
import balancesService from './balances';

window.mtServices = {
  balancesService
};
